import adminAppTagsEnUS from './locales/en-US/admin-app-tags'
import adminAgentToolsEnUS from './locales/en-US/admin-agent-tools'
import adminIdpEnUS from './locales/en-US/admin-idp'
import adminAppsEnUS from './locales/en-US/admin-apps'
import adminModelCallLogsEnUS from './locales/en-US/admin-model-call-logs'
import adminModelKeysEnUS from './locales/en-US/admin-model-keys'
import adminModelProviderEnUS from './locales/en-US/admin-model-provider'
import adminOverviewEnUS from './locales/en-US/admin-overview'
import adminOrganizationEnUS from './locales/en-US/admin-organization'
import adminProfileEnUS from './locales/en-US/admin-profile'
import adminSettingsEnUS from './locales/en-US/admin-settings'
import adminStatisticsEnUS from './locales/en-US/admin-statistics'
import authEnUS from './locales/en-US/auth'
import chatEnUS from './locales/en-US/chat'
import shellEnUS from './locales/en-US/shell'
import userAppsEnUS from './locales/en-US/user-apps'
import userProfileEnUS from './locales/en-US/user-profile'
import wecomBindingEnUS from './locales/en-US/wecom-binding'
import adminAppTagsZhHans from './locales/zh-Hans/admin-app-tags'
import adminAgentToolsZhHans from './locales/zh-Hans/admin-agent-tools'
import adminIdpZhHans from './locales/zh-Hans/admin-idp'
import adminAppsZhHans from './locales/zh-Hans/admin-apps'
import adminModelCallLogsZhHans from './locales/zh-Hans/admin-model-call-logs'
import adminModelKeysZhHans from './locales/zh-Hans/admin-model-keys'
import adminModelProviderZhHans from './locales/zh-Hans/admin-model-provider'
import adminOverviewZhHans from './locales/zh-Hans/admin-overview'
import adminOrganizationZhHans from './locales/zh-Hans/admin-organization'
import adminProfileZhHans from './locales/zh-Hans/admin-profile'
import adminSettingsZhHans from './locales/zh-Hans/admin-settings'
import adminStatisticsZhHans from './locales/zh-Hans/admin-statistics'
import authZhHans from './locales/zh-Hans/auth'
import chatZhHans from './locales/zh-Hans/chat'
import shellZhHans from './locales/zh-Hans/shell'
import userAppsZhHans from './locales/zh-Hans/user-apps'
import userProfileZhHans from './locales/zh-Hans/user-profile'
import wecomBindingZhHans from './locales/zh-Hans/wecom-binding'

export const supportedLanguages = ['en-US', 'zh-Hans'] as const

export type SupportedLanguage = (typeof supportedLanguages)[number]

export const fallbackLanguage: SupportedLanguage = 'zh-Hans'

export const resources = {
  'en-US': {
    adminAgentTools: adminAgentToolsEnUS,
    adminAppTags: adminAppTagsEnUS,
    adminIdp: adminIdpEnUS,
    adminApps: adminAppsEnUS,
    adminModelCallLogs: adminModelCallLogsEnUS,
    adminModelKeys: adminModelKeysEnUS,
    adminModelProvider: adminModelProviderEnUS,
    adminOverview: adminOverviewEnUS,
    adminOrganization: adminOrganizationEnUS,
    adminProfile: adminProfileEnUS,
    adminSettings: adminSettingsEnUS,
    adminStatistics: adminStatisticsEnUS,
    auth: authEnUS,
    chat: chatEnUS,
    shell: shellEnUS,
    userApps: userAppsEnUS,
    userProfile: userProfileEnUS,
    wecomBinding: wecomBindingEnUS,
  },
  'zh-Hans': {
    adminAgentTools: adminAgentToolsZhHans,
    adminAppTags: adminAppTagsZhHans,
    adminIdp: adminIdpZhHans,
    adminApps: adminAppsZhHans,
    adminModelCallLogs: adminModelCallLogsZhHans,
    adminModelKeys: adminModelKeysZhHans,
    adminModelProvider: adminModelProviderZhHans,
    adminOverview: adminOverviewZhHans,
    adminOrganization: adminOrganizationZhHans,
    adminProfile: adminProfileZhHans,
    adminSettings: adminSettingsZhHans,
    adminStatistics: adminStatisticsZhHans,
    auth: authZhHans,
    chat: chatZhHans,
    shell: shellZhHans,
    userApps: userAppsZhHans,
    userProfile: userProfileZhHans,
    wecomBinding: wecomBindingZhHans,
  },
} as const
